import React from 'react';

import { FormProgress } from './form-progress';
import { ModalFormHeader } from './modal-form-header';

interface ModalFormContainerProps {
  icon: string;
  header: string;
  step?: number;
  steps?: number;
  children: React.ReactNode;
}

export function ModalFormContainer({
  icon,
  header,
  step,
  steps,
  children
}: ModalFormContainerProps) {
  return (
    <div className="modal-form-container">
      <ModalFormHeader 
        icon={icon}
        header={header}
        step={step}
        steps={steps}
      />
      <FormProgress
        step={step}
        steps={steps}
      />
      <form>
        {children}
      </form>
    </div>
  );
}
